import { render, staticRenderFns } from "./TableRiskAppraisal_5x4.vue?vue&type=template&id=ee0ea806&scoped=true"
import script from "./TableRiskAppraisal_5x4.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal_5x4.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal_5x4.vue?vue&type=style&index=0&id=ee0ea806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0ea806",
  null
  
)

export default component.exports